module.exports = __webpack_public_path__ + "~@/assets/img/log.545428c3.png";